import { PetAge } from "../../enums/petAge";
import { SeeingVetAnswer } from "../../enums/seeingVetAnswer";
import { Gender } from "../../enums/gender";

export default class PetDetailModel {
    id: number = 0;
    caseId: number = 0;
    name: string = "";
    speciesId: number | null = null;
    breedId: number | null = null;
    breedNotes: string | null = null;
    petWeight: number | null = null;
    unitOfWeight: string = "";
    petAge: PetAge | null = null;
    petAgeText: string = "";
    isSeeingAVet: SeeingVetAnswer = SeeingVetAnswer.No;
    isSeeingAVetText: string = "";
    isAppointmentMade: boolean | null = null;
    lastVaccinated: Date | null = null;
    petDetailsId: number | null = null;
    speciesName: string = "";
    haveEssentialInfoSheet: boolean | null = null;
    anythingEssentialInfoSheet: boolean | null = null;
    sex: Gender | null = null;
    isOnMedication: boolean | null = false;
    medicationNotes: string = "";
    isNeutered: boolean | null = false;
    secondOpinion: boolean = false;
    breedName: string | null = null;

    constructor() { }
}
